import React from 'react';
import { Icon, Tooltip, Typography } from 'antd';
import { getAttachmentName } from '../../utils/getAttachmentName';
import { downloadAttachment } from '../../../../helpers/attachments/downloadAttachment';
import { useAttachmentAction } from '../../services/attachmentAction';
import { useAttachment } from '../../providers/attachment';
import styles from './index.module.scss';

const NameBlock = () => {
  const attachment = useAttachment();

  return (
    <div className={styles.root}>
      <Name attachment={attachment} />
      {attachment.type && <Type type={attachment.type} />}
    </div>
  );
};

export default NameBlock;

function Name({ attachment }) {
  const { loading, handler: onClick } = useAttachmentAction({
    attachment,
    action: downloadAttachment,
  });

  const name = getAttachmentName(attachment);

  return (
    <div className={styles.nameWrapper}>
      <Tooltip title={getTooltipTitle(name)}>
        <Typography.Text ellipsis onClick={onClick} className={styles.name}>
          {name ?? 'Без имени'}
        </Typography.Text>
      </Tooltip>
      {loading && <Icon type="loading" />}
    </div>
  );
}

function Type({ type }) {
  return (
    <Typography.Text className={styles.type}>
      <Typography.Text strong>Тип: </Typography.Text>
      {type.name}
    </Typography.Text>
  );
}

function getTooltipTitle(name) {
  return name ? `Скачать «${name}»` : 'Скачать';
}
